import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../../Services/styleAllServices.css";

import hardscapeDesignGravelDriveway from "../../../../assets/img/green-lawn-with-rocks..png";
import retainingWallWithLighting from "../../../../assets/img/lawn-mowing-service-residential-yard.jpeg";
import burhanTeam from "../../../../assets/img/burhan-team.jpg";

export default function LangleyLawnMowing() {
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }

    // TITLE - Optimized for "Lawn Mowing Langley" (Service + Location format)
    const newTitle = "Lawn Mowing Langley | Professional Grass Cutting Service | BUR-HAN";
    document.title = newTitle;

    // META DESCRIPTION - Compelling with keywords and benefits
    const newDescription = "Professional lawn mowing Langley. Eco-friendly electric mowing service for residential & commercial properties. Weekly, bi-weekly & custom schedules. Free quote: 604-983-2687";
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      descriptionMetaTag = document.createElement("meta");
      descriptionMetaTag.setAttribute("name", "description");
      descriptionMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(descriptionMetaTag);
    }

    // KEYWORDS - Comprehensive Langley mowing keywords
    const newKeywords = [
      "lawn mowing Langley",
      "lawn mowing near me Langley",
      "grass cutting Langley",
      "lawn care Langley",
      "residential lawn mowing Langley",
      "commercial lawn mowing Langley",
      "lawn maintenance Langley",
      "weekly lawn mowing Langley",
      "eco-friendly lawn mowing Langley",
      "electric lawn mowing Langley",
      "professional lawn mowing Langley",
      "lawn service Langley",
      "best lawn mowing Langley",
      "affordable lawn mowing Langley",
      "lawn cutting service Langley"
    ].join(", ");
    
    let keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      keywordsMetaTag = document.createElement("meta");
      keywordsMetaTag.setAttribute("name", "keywords");
      keywordsMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(keywordsMetaTag);
    }

    // GEO META TAGS - Langley specific
    let geoTag = document.querySelector('meta[name="geo.placename"]');
    if (geoTag) {
      geoTag.setAttribute("content", "Langley, British Columbia");
    } else {
      geoTag = document.createElement("meta");
      geoTag.setAttribute("name", "geo.placename");
      geoTag.setAttribute("content", "Langley, British Columbia");
      document.head.appendChild(geoTag);
    }

    // OPEN GRAPH TAGS
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      ogTitleTag = document.createElement("meta");
      ogTitleTag.setAttribute("property", "og:title");
      ogTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(ogTitleTag);
    }

    let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      ogDescriptionTag = document.createElement("meta");
      ogDescriptionTag.setAttribute("property", "og:description");
      ogDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(ogDescriptionTag);
    }

    let ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      ogUrlTag.setAttribute("content", canonicalUrl);
    } else {
      ogUrlTag = document.createElement("meta");
      ogUrlTag.setAttribute("property", "og:url");
      ogUrlTag.setAttribute("content", canonicalUrl);
      document.head.appendChild(ogUrlTag);
    }

    // TWITTER CARDS
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", newTitle);
    } else {
      twitterTitle = document.createElement("meta");
      twitterTitle.setAttribute("name", "twitter:title");
      twitterTitle.setAttribute("content", newTitle);
      document.head.appendChild(twitterTitle);
    }

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute("content", newDescription);
    } else {
      twitterDescription = document.createElement("meta");
      twitterDescription.setAttribute("name", "twitter:description");
      twitterDescription.setAttribute("content", newDescription);
      document.head.appendChild(twitterDescription);
    }

  }, [location.pathname]);

  // Schema markup for Lawn Mowing Langley
  useEffect(() => {
    const schemaScript = document.createElement("script");
    schemaScript.setAttribute("type", "application/ld+json");
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Lawn Mowing Services Langley",
      "serviceType": "Lawn Mowing",
      "provider": {
        "@type": "LocalBusiness",
        "name": "BUR-HAN Garden & Lawn Care",
        "url": "https://bur-han.ca",
        "telephone": "+1-604-983-2687",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2323 Old Dollarton Rd Unit A",
          "addressLocality": "North Vancouver",
          "addressRegion": "BC",
          "postalCode": "V7H 1A9",
          "addressCountry": "CA"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "Langley",
        "containedIn": {
          "@type": "State",
          "name": "British Columbia"
        }
      },
      "description": "Professional lawn mowing services in Langley. Eco-friendly electric mowing for residential and commercial properties. Weekly, bi-weekly, and custom schedules available."
    });
    
    const existingSchema = document.querySelector('script[data-schema="langley-mowing"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    schemaScript.setAttribute("data-schema", "langley-mowing");
    document.head.appendChild(schemaScript);
  }, []);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        {/* H1 - Optimized with primary keyword first */}
        <h1 data-aos="zoom-in">Lawn Mowing Langley </h1>
      </div>
      <div className="serviceItemsMain">
        <section id="about" className="about"  >
        <h2 data-aos="fade-down" style={{ margin: "2vw",textAlign: "center",fontSize: "2vw",textTransform: "uppercase"}}>
          "Enhancing the beauty and function of your outdoor space with expert
          lawn mowing services."
        </h2>
        <hr />
        <div className="row writtenContent" >
          <div
            className="col-lg-6 order-1 order-lg-2 px-5 "
            data-aos="fade-left"
          >
            <img loading="lazy"
              src={burhanTeam}
              alt="BUR-HAN Landscaping Team "
              className="img-fluid bhTeam"
            />
          </div>
          <div
            className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content"
            data-aos="fade-right"
          >
            <div className="corner-left">
              <div className="title" data-aos="zoom-in">
                <h3>BUR-HAN GARDEN & LAWN CARE</h3>
              </div>
              <div
                className="aboutSentence"
                data-aos="fade-right"
                data-duration="2000"
              >
                <p>
                  BUR-HAN Garden & Lawn Care has been providing Residential &
                  Commercial landscaping services for over 30 years.{" "}
                  <a href="/our-projects" className="internal-link">
                    View our completed landscaping projects here.
                  </a>{" "}
                  Langley's mix of established Township neighbourhoods and City of Langley urban properties creates diverse lawn mowing needs across the region. The Fraser Valley climate supports vigorous grass growth through a long season, and Langley's larger lots in communities like Willoughby and Murrayville benefit from consistent, professional mowing. BUR-HAN's electric mowing service brings reliable care to Langley properties throughout the growing season.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
        {/* -------------- BANNER SECTION -------------*/}
        <div className="banner-section">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <h3 className="heading" data-aos="fade-right">
                  "Empowering Progress, Igniting <span> Results!" </span>
                </h3>
              </div>
              <div
                className="col-lg-6 col-md-12 col-sm-12"
                data-aos="fade-left"
              >
                <p className="text">
                  "Revitalize your outdoor space with our expert landscaping
                  maintenance services, ensuring a thriving and picturesque
                  environment year-round."
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* -------------- about SECTION -------------*/}
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy"
              src={hardscapeDesignGravelDriveway}
              alt="Beautiful home with a gravel driveway and landscaped hedges, showcasing hardscape design"
              title="Hardscape Design Featuring a Gravel Driveway and Landscaped Hedges"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <span className="caption d-block mb-2 font-weight-bold">
              Outstanding Services
            </span>
            <h3 className="headingImageText text-uppercase ">
            Langley Lawn Mowing</h3>
            <p>
            Transform your outdoor space with BUR-HAN's exceptional Lawn Mowing services in Langley. Our team is dedicated to delivering precision and care with every cut, ensuring that your lawn remains lush, vibrant, and impeccably maintained throughout the seasons. We continuously refine our methods and techniques to provide you with a service that not only enhances your property’s appearance but also supports the local environment. Our team undergoes regular training to stay current with industry standards and best practices in lawn care. Whether you need routine mowing or a complete lawn makeover, we are here to help you achieve a well-manicured landscape that adds value and beauty to your property.
            </p>
          </div>
        </section>
        <section className="section-container">
          <div class="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
              Why choose BUR-HAN for your
              <br /> Lawn Mowing needs in Langley?
            </h3>
            <ul>
              <li>
                <strong>Customized Lawn Care Plans:</strong> We recognize that every lawn is unique, and our team tailors services to meet your specific needs and preferences.
              </li>
              <li>
                {" "}
                <strong>Expert Precision:</strong> Our skilled lawn care professionals use the latest equipment and techniques to ensure a clean, even cut every time.
              </li>
              <li>
                {" "}
                <strong> Eco-Friendly Practices:</strong> We prioritize sustainable lawn care by utilizing electric, battery-powered equipment that reduces noise and emissions.
              </li>
              <li>
                <strong>Seasonal Expertise: </strong>Our team understands the seasonal requirements of Langley's climate, ensuring your lawn stays healthy and beautiful year-round.
              </li>
              <li>
                <strong>Property Value Enhancement:</strong> A well-maintained lawn significantly enhances curb appeal and property value. Trust us to keep your landscape looking its best.
              </li>
            </ul>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy"
              src={retainingWallWithLighting}
              alt="Elegant retaining wall with built-in lighting and landscaped garden at dusk"
              title="Retaining Wall with Built-In Lighting and Dusk Landscaping"
            />{" "}
          </div>
        </section>


        <section className="how-it-works" data-aos="fade-up">
          <div className="container py-4 px-5">
            <h3 className="headingImageText text-uppercase mb-4">How Our Langley Lawn Mowing Service Works</h3>
            <div className="steps-grid">
              <div className="step-item">
                <span className="step-number">1</span>
                <h4>Schedule Your Service</h4>
                <p>Contact BUR-HAN to set up a weekly, bi-weekly, or custom mowing schedule that fits your Langley property. We accommodate residential, commercial, and strata clients across the area.</p>
              </div>
              <div className="step-item">
                <span className="step-number">2</span>
                <h4>We Arrive & Mow</h4>
                <p>Our trained crew arrives with fully electric, battery-powered equipment. We cut at the optimal height for the season, trim edges, and blow clippings from hard surfaces — leaving your lawn clean and precise.</p>
              </div>
              <div className="step-item">
                <span className="step-number">3</span>
                <h4>Consistent Results Every Visit</h4>
                <p>The same professional standard every time — no surprise no-shows, no damage to your property. If you have feedback, we address it immediately. Your Langley lawn stays looking its best all season long.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Lawn Care Services in Langley</h2>
          <div className="lawnCareLinks-grid">
      <a href="/lawn-aeration-langley">
        <strong>Lawn Aeration Langley</strong>
        <span>Core aeration for healthier roots</span>
      </a>
      <a href="/lawn-fertilizing-langley">
        <strong>Lawn Fertilizing Langley</strong>
        <span>Seasonal fertilization programs</span>
      </a>
      <a href="/landscaping-langley">
        <strong>Landscaping Langley</strong>
        <span>Full-service landscape maintenance</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6 ">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our Get a Quote page, and let our expert landscaping
                  team bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs.{" "}
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Get A Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
